import { Box, Modal, Typography } from '@mui/material';
import { useState } from 'react';
import Images from '../utils/Images';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import axios from 'axios';
import { API } from '../utils/Api';
import toast from "react-hot-toast";

const BirthdayModal = ({ openBirthday, handleCloseBirthday }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [calendarOpen, setCalendarOpen] = useState(false);
    const token = localStorage.getItem("token");
    const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setCalendarOpen(false);
    };

    const handleUpdateProfile = async () => {
        if (!selectedDate) {
            toast.error("Please select your birthday");
            return;
        }

        const dateObject = new Date(selectedDate);
        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObject.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        try {
            const response = await axios.put(`${API.BASE_URL}user/profile/update`, {
                dob: formattedDate,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Birthday added successfully!");
            handleCloseBirthday();
        } catch (error) {
            console.error('Error updating profile:', error);
            toast.error(error?.response?.data?.error || "Something went wrong");
        }
    };

    return (
        <Modal
            open={openBirthday}
            onClose={handleCloseBirthday}
            aria-labelledby="birthday-modal-title"
            sx={{ border: '0' }}
        >
            <Box
                className="birthdayModal"
                sx={{
                    outline: 'none',
                    mx: 'auto',
                    mt: 8,
                    bgcolor: '#fff',
                    borderRadius: 3,
                    overflow: 'hidden',
                }}
            >
                <Box>
                    <img src={Images.birthdayModal} alt="Birthday Offer" style={{ width: '100%', borderRadius: '12px' }} />

                    <Typography variant="h6" textAlign="center">Birthday perks unlocked!</Typography>

                    <Typography textAlign="center" sx={{ fontSize: 14 }}>
                        The party doesn’t stop on your birthday — get <strong>50% off</strong> on a special day of your birthday month!
                    </Typography>

                    <Box width="100%" mt={1}>
                        <Box
                            onClick={() => setCalendarOpen(!calendarOpen)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                border: '1px solid #ccc',
                                borderRadius: 2,
                                p: 2,
                                cursor: 'pointer',
                            }}
                        >
                            <Typography sx={{ color: '#9d9d9d', fontWeight: '600' }}>
                                {selectedDate ? selectedDate.toDateString() : 'Select Date'}
                            </Typography>
                            <ExpandMoreIcon />
                        </Box>
                        {calendarOpen && (
                            <Box mt={1}>
                                <Calendar
                                    onChange={handleDateChange}
                                    value={selectedDate}
                                    maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 10))}
                                />
                            </Box>
                        )}
                    </Box>

                    {!calendarOpen && (
                        <>
                            <Box className="countButton" onClick={() => handleUpdateProfile()} sx={{ mt: 2, opacity: selectedDate ? 1 : 0.5, pointerEvents: selectedDate ? 'auto' : 'none' }}>
                                Count me in!
                            </Box>
                            <Typography onClick={() => handleCloseBirthday()} sx={{ mt: 2, color: '#a1a1a1', textAlign: 'center', cursor: 'pointer' }}>Remind me later</Typography>
                        </>
                    )}
                </Box>
            </Box>
        </Modal>
    );
};

export default BirthdayModal;
